import React from "react";
import { Link, Text, theme, Icon } from "@clearabee/ui-library-native";
import { View } from "react-native";
import { Spinner } from "components/Core/Spinner/Spinner";

interface DownloadLinkProps {
  linkOnPress: () => void;
  isLoading: boolean;
  linkText: string;
  isSuccess?: boolean;
}

export const DownloadLink = ({
  isLoading,
  linkOnPress,
  linkText,
  isSuccess,
}: DownloadLinkProps): React.ReactElement => {
  return (
    <View
      style={{
        minWidth: 160,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.spacing.xsmall,
      }}
    >
      <Link role="button" onPress={linkOnPress}>
        <Text fontSize="small">{linkText} </Text>

        <Icon.Download size="small" />
      </Link>

      {isLoading && <Spinner style={{ marginLeft: theme.spacing.xsmall2 }} />}

      {isSuccess && <Icon.Tick2 size="small" color="positive" />}
    </View>
  );
};
